import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dClearanceTranslations() {
  return {
    usage: {
      text: $localize`:@@scan3dClearance.usage:To start, load a point cloud and a model into the viewer.  Then select a model part to compare with the loaded point cloud.`,
      desc: 'Description how to use the clearance styling component.',
    },
    defaultTransparent: {
      text: $localize`:@@scan3dClearance.defaultTransparent:Hide points beyond bands`,
      desc: 'Label for the switch to hide points beyond clearance bands.',
      limit: 30,
    },
    defaultColor: {
      text: $localize`:@@scan3dClearance.defaultColor:Points beyond bands`,
      desc: 'Label for the default color to use when not part of clearance bands.',
      limit: 30,
    },
    bands: {
      text: $localize`:@@scan3dClearance.bands:Clearance Bands`,
      desc: 'Colored distance thresholds in a 3D viewer showing how close a point cloud is to the model.',
      limit: 30,
    },
    errorAscending: {
      text: $localize`:@@scan3dClearance.errorAscending:Start values must be in ascending order.`,
      desc: 'Error message when clearance bands start values are not in ascending order.',
      limit: 30,
    },
    errorInvalidBand: {
      text: $localize`:@@scan3dClearance.errorInvalidBand:Invalid band configuration.`,
      desc: 'Error message when a clearance band is not configured correctly.',
      limit: 30,
    },
  } satisfies TranslationMap;
}
